/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { Person } from '../person'
import { ChapterNavigation } from 'components/ChapterNavigation'
import { Box } from 'components/Box'

// TODO Set the correct article ID here
const ARTICLE_ID = '420518480480'
const isDesk = window.innerWidth > 768

const ChapterNavigationContent = [
  {
    name: (
      <>
        <nobr>Angélique Beldner</nobr>
      </>
    ),
    id: 'beldner'
  },
  {
    name: (
      <>
        <nobr>Serena O. Dankwa</nobr>
      </>
    ),
    id: 'dankwa'
  },
  {
    name: (
      <>
        <nobr>Gabriella Binkert</nobr>
      </>
    ),
    id: 'binkert'
  },
  {
    name: (
      <>
        <nobr>Daniel Blumer</nobr>
      </>
    ),
    id: 'blumer'
  },
  {
    name: (
      <>
        <nobr>Sandro Brotz</nobr>
      </>
    ),
    id: 'brotz'
  },
  {
    name: (
      <>
        <nobr>Rahel El-Maawi</nobr>
      </>
    ),
    id: 'el-maawi'
  } /*,

  {
    name: (
      <>
        <nobr>Q&A zur Sprache</nobr>
      </>
    ),
    id: 'sprache'
  },
  {
    name: (
      <>
        <nobr>Links zum Thema</nobr>
      </>
    ),
    id: 'links'
  }
  */
]

export function AppComponent() {
  const [currentChapter, setCurrentChapter] = useState('not set')
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted titleImage  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>«Unser Land ist offener geworden»</h1>
            <h2>
              Wo steht die Schweiz ein Jahr nach den grossen «Black Lives
              Matter»-Kundgebungen? Sechs Personen blicken zurück - und nach
              vorn.
            </h2>
          </div>
        </div>
      </header>
      <div className='content'>
        <div className='ui container'>
          <div className='ta secondary caption'>
            Demonstrierende während eines Protests in Lausanne im Juni 2020.
            Foto: Laurent Gillieron
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
        <ChapterNavigation
          content={ChapterNavigationContent}
          current={currentChapter}
        />
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Alexandra Kedves, Martin Fischer, Aleksandra Hiltmann
            </div>
            <div className='ta updated'>Aktualisiert am 12. Juni 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Vor etwas mehr als einem Jahr wurde in den USA der Afroamerikaner
              George Floyd von einem Polizisten ermordet. Die «Black Lives
              Matter»-Proteste gegen das Verbrechen und gegen Rassismus
              schwappten bald auf andere Länder über, auch auf die Schweiz.
              Trotz Corona gingen Tausende auf die Strassen, um rassistische
              Diskriminierung hierzulande anzuprangern. Ein Jahr danach fragen
              wir bei jenen nach, die sich an der Debatte beteiligt haben: Was
              hat das mit unserem Land gemacht? Wie erlebten die sechs
              Protagonistinnen und Protagonisten dieses letzte Jahr?
            </p>
          </div>
        </div>

        <Person
          img={require('../../images/beldner.jpg')}
          id='beldner'
          quote='Unser Land ist offener geworden'
          info='Angélique Beldner, TV-Moderatorin und Protagonistin im «Reporter»-Film «Rassismus in der Schweiz – Der Sommer, in dem ich ‹Schwarz› wurde»'
          setCurrent={setCurrentChapter}
          bottomMargin='1em'
        >
          <p>
            <span className='mark'>«</span>Ich hätte es nicht für möglich
            gehalten, dass ich mit Mitte 40 einen so grossen inneren Wandel
            vollziehen kann. Die «Black Lives Matter»-Bewegung hat meinen Blick
            auf unser Land in Bezug auf Rassismus verändert, aber auch den Blick
            auf meinen persönlichen Umgang damit.
          </p>
          <p>
            Ich habe heute Worte für viele Dinge, die mir bis vor einem Jahr
            noch fehlten. Ich kann benennen, was ich empfinde. Und ich kann es
            so erklären, dass ich das Gefühl habe, dass mein Gegenüber es
            versteht.
          </p>
          <p>
            Ich spüre, dass viele Menschen deutlich achtsamer geworden sind. Sie
            sind bereit, aufmerksamer hinzuschauen – bei anderen und auch bei
            sich selbst. Daraus entstehen oft interessante Gespräche. Ich werde
            öfter nach meiner Meinung zum Thema Rassismus gefragt, aber man sagt
            mir auch öfter ungefragt die Meinung. Auch das sind für mich
            Gesprächsangebote, die ich eigentlich immer anzunehmen versuche.
            Denn genau diese Offenheit ist es doch, die uns am Ende
            weiterbringt.
          </p>
          <p>
            Auf den «Reporter»-Film erhielt ich gegen 1000 Rückmeldungen. Viele
            haben mir sehr persönliche Geschichten erzählt. Da war es mir
            wichtig, diese Nachrichten auch gebührend zu beantworten. Und
            gleichzeitig hat es mich emotional durchgeschüttelt. Da waren die
            verständnisvollen Reaktionen, die unterstützenden, die von
            Betroffenen mit ihren eigenen Geschichten. Aber auch die kritischen,
            die besserwisserischen und die versteckt oder gar offen
            rassistischen.
          </p>
          <p>
            Ich erkannte, dass diese Rückmeldungen ein eindrückliches Bild
            darüber abgeben, wo unser Land nach dem Sommer 2020 stand. Daraus
            ergab sich die Idee, diese Rückmeldungen in ein Buch einfliessen zu
            lassen, das ich nun zusammen mit dem Schriftsteller Martin R. Dean
            geschrieben habe. Das Buch wird voraussichtlich im Herbst
            erscheinen.
          </p>
          <p>
            Ich finde, unser Land ist offener geworden. Aber ich habe manchmal
            auch Angst vor einer Rückwärtsspirale. Die Debatten werden teilweise
            sehr aggressiv geführt. Doch wer sich angegriffen fühlt, entwickelt
            eine Abwehrhaltung. In gewissen Diskussionen geht es mir zu sehr
            darum, wer nun recht hat und wer falsch liegt. Wir müssen aufpassen,
            dass wir dabei das grosse Ganze nicht aus den Augen verlieren.
          </p>
          <p>
            Ich wünsche mir, dass wir die Debatte weiterführen. Konstruktiv,
            ohne einander anzuklagen. Wenn ich über Rassismus lese, lese ich oft
            über das «wir» und das «ihr». Ich fände es schön, wenn wir das nicht
            trennen müssten. Wir sind eine Gesellschaft und Rassismus ist ein
            Thema, das uns alle etwas angeht.
            <span className='mark'>»</span>
          </p>
          <hr />
          <p>
            <i>
              Den SRF-«Reporter» «Rassismus in der Schweiz – Der Sommer, in dem
              ich ‹Schwarz› wurde» gibts{' '}
              <Link
                allowWordWrap
                href='https://www.youtube.com/watch?v=9t92aF1w3zY'
              >
                hier in voller Länge
              </Link>
              .
            </i>
          </p>
        </Person>

        <Person
          img={require('../../images/dankwa.jpg')}
          id='dankwa'
          quote='Die ‹BLM›-Proteste haben einigen Schwarzen Menschen ein neues Selbstbewusstsein gegeben'
          info='Serena O. Dankwa, Sozialanthropologin und Geschlechterforscherin; sie ist für eine NGO tätig.'
          setCurrent={setCurrentChapter}
        >
          <p>
            <span className='mark'>«</span>Die «BLM»-Proteste im letzten Sommer
            haben einigen Schwarzen Menschen in der Schweiz ein neues
            Selbstbewusstsein gegeben, um rassistische Situationen als solche
            anzusprechen. Und gesellschaftlich hat sich ein grösseres
            Problembewusstsein entwickelt. Das ist spürbar und begrüssenswert.
            Ich zum Beispiel werde oft an Podien eingeladen, und in den Medien
            haben Menschen von ihren Erfahrungen mit Alltagsrassismus erzählt.
          </p>
          <p>Aber institutionell hat sich nicht allzu viel getan.</p>
          <p>
            In Polizei, Schulen, Sozialämtern und Asylzentren gibt es eine Menge
            verdeckten Rassismus. Ein Beispiel ist die Gewalt von
            Securitas-Personal gegenüber Asylsuchenden. Auch die Suizidversuche
            aufgrund der perspektivlosen Situation in den Bundesasylzentren
            sprechen Bände. Ein strukturelles Problem ist zudem der «racial
            capitalism», der mit der Ausbeutung von Menschen aus dem globalen
            Süden operiert; dieser widerspiegelt sich in der Migrationspolitik.
          </p>
          <p>
            Ich wurde an der Uni auch schon für eine Putzfrau gehalten statt für
            eine Dozentin. Das sagt etwas darüber aus, wo in der Schweiz
            Schwarze Menschen erwartet und geduldet werden, aber es genügt
            nicht, sich darüber aufzuregen. Wichtiger wäre, sich mit dem
            Reinigungspersonal zu solidarisieren, bessere Arbeitsbedingungen und
            eine gerechtere Betriebskultur einzufordern.
          </p>
          <p>
            In Zürich fragte 2020 eine Gruppe Schwarzer Künstler*innen über 70
            Kulturbetriebe, was sie hinsichtlich Rassismus unternähmen – nur
            drei antworteten. Man darf also die Scheinprominenz der Thematik
            oder einzelner Personen durch ein kurzes Zeugnis in den Medien nicht
            mit echtem Veränderungswillen verwechseln.
          </p>
          <p>
            Auch das Interesse an Testimonials von «Betroffenen» ist für mich
            eine zweischneidige Angelegenheit. Menschen werden dabei oftmals
            verheizt und als Feigenblatt benutzt. Zudem lenkt es ab von den
            institutionellen Ungerechtigkeiten. Und davon, dass die Bringschuld
            eigentlich bei denen liegt, die vom Rassismus profitieren, wie die
            afroamerikanische Autorin Toni Morrison immer betonte. Sie müssen
            sich «racial literacy» erarbeiten, ihre Privilegien und ihr Unwissen
            erkennen.
            <span className='mark'>»</span>
          </p>
        </Person>

        <Person
          img={require('../../images/binkert.jpg')}
          id='binkert'
          quote='Die Diskussion um rassistische Begriffe finde ich nach wie vor übertrieben'
          info='Gabriella Binkert, 2020 als Gemeindepräsidentin (SVP) im Val Müstair gewählt, Geschäftsführerin einer Firma'
          setCurrent={setCurrentChapter}
        >
          <p>
            <span className='mark'>«</span>Ich war überwältigt von den
            Reaktionen auf meinen SRF-«Arena»-Auftritt im Juni 2020. Zu 99
            Prozent waren sie positiv. Im Tal kamen viele ältere Frauen auf mich
            zu, um über Rassismus zu sprechen. «Sag mal», fragten sie, «hattest
            du Probleme? Wie war das, als du zu uns ins Tal gekommen bist?» Ich
            antwortete, dass ich keine Probleme gehabt hätte. «Ihr wart toll.»
            Viele sagten auch, dass sie stolz auf mich seien. Ich finde es gut,
            dass man sich traute, darüber zu sprechen. Die Leute sind nicht nur
            hier im Tal offener geworden, Rassismus zu thematisieren.
          </p>
          <p>
            Als ich dieses Jahr Schwarze Personen als Expertinnen und Experten
            im Fernsehen sah, fragte ich mich: Wurden sie nur angestellt, weil
            sie Schwarz sind? Ich glaube, viele Arbeitgeber haben Angst, sich
            die Finger zu verbrennen, wenn sie eine nicht-weisse Person für
            einen Job ablehnen. Das sollte nicht sein. Der Mensch und seine
            Leistung sollten im Vordergrund stehen, nicht das Aussehen, das
            Geschlecht oder die Hautfarbe. In meinen Augen wurde ich auch nicht
            zur Gemeindepräsidentin gewählt, weil ich eine Frau bin.
          </p>
          <p>
            Über sogenannte rassistische Begriffe denke ich gleich wie vor einem
            Jahr. Ich finde die Diskussion darum übertrieben. Man kann auch
            jemandem korrekt sagen, er sei eine Schwarze Person, und es im Ton
            doch abwertend meinen. Dennoch sind sich die Leute bewusst geworden,
            wie man sich anständig ausdrückt. Auch ich würde heute kontern:
            N-li, das sagt man wirklich nicht mehr.
          </p>
          <p>
            Auch bezüglich der Kolonialgeschichte hat sich meine Position nicht
            verändert. Wenn wir über Kolonialismus sprechen wollen, müssen wir
            auch im Bezug auf heute ehrlich sein: Viele Länder behandeln
            Menschen noch immer wie Sklaven. Das hört nicht auf, nur weil wir
            Statuen niederreissen.
          </p>
          <p>
            Ich habe keinen neuen Zugang zum Thema gefunden, ich hatte immer
            meine Haltung und bin immer einfach geradeaus durchs Leben gegangen
            mit meiner dunklen Hautfarbe. Man muss aufpassen, dass man sich
            selbst nicht etwas vorjammert. Ich habe mich schon als Kind gewehrt.
            Wenn mich heute jemand fragt, ob ich Deutsch spreche, könnte ich
            natürlich beleidigt sein. Aber man kann darüberstehen. Jemand, der
            in der Vergangenheit wirklich Probleme hatte, der verfolgte die
            «Black Lives Matter»-Diskussion in diesem Jahr aber bestimmt anders
            als ich.
          </p>
          <p>
            Und weil es diese Probleme noch immer gibt, finde ich es wichtig,
            dass Kinder bereits in der Schule mehr Toleranz lernen. Nicht nur
            Schwarzweiss. Sondern einfach betreffend Menschen – mit
            Migrationshintergrund, mit Handicap. Und jene, die zu uns kommen,
            müssen sich auch öffnen und den Gegebenheiten anpassen. Wir
            profitieren alle, wenn wir offener sind.
            <span className='mark'>»</span>
          </p>
        </Person>

        <Person
          img={require('../../images/blumer.jpg')}
          id='blumer'
          quote='Beim Thema Racial Profiling wird es immer Konflikte geben'
          info='Daniel Blumer, Kommandant Stadtpolizei Zürich'
          setCurrent={setCurrentChapter}
        >
          <p>
            <span className='mark'>«</span>Als ich letzten Sommer die vielen
            Menschen auf der Strasse sah, hatte ich Verständnis für deren
            emotionalen Aufruhr. Für die Polizeiarbeit habe ich in diesem Jahr
            aber keine neuen Erkenntnisse erlangt aus den Kundgebungen oder der
            Rassismus-Debatte. Das Thema Racial Profiling beschäftigt uns seit
            langem, aufgrund eines breit angelegten Projekts seit vier Jahren
            besonders intensiv. Wir haben auf Vorwürfe reagiert und neue Regeln
            geschaffen. Unter anderem müssen Polizeiangehörige nun den Grund für
            eine Personenkontrolle nennen und die Kontrolle über eine App
            erfassen.
          </p>
          <Box title='Racial Profiling in der Schweiz'>
            <p>
              Verschiedene zivilgesellschaftliche Organisationen sowie
              Forschungsteams weisen immer wieder darauf hin, dass die Polizei
              in ihrer Arbeit Personen rassistisch diskriminiert und dass Racial
              Profiling in der Schweiz weiterhin ein Problem darstellt. Unter
              anderem berichteten diverse NGOs in ihrem Schattenbericht zuhanden
              des UNO-Ausschusses gegen Rassendiskriminierung (CERD) darüber.
              Der Ausschuss kontrolliert das Übereinkommen der Vereinten
              Nationen gegen Rassendiskriminierung. Die Schweiz trat diesem 1994
              bei.
            </p>
            <p>
              «Obwohl (...) durchaus Massnahmen gegen diskriminierende Praxen
              angepackt und umgesetzt wurden, stellt sich weiterhin die
              Herausforderung, Vorfälle nicht als Fehlverhalten einzelner
              Beamter zu behandeln, sondern die institutionelle und strukturelle
              Dimension von rassistischem Profiling anzugehen», schreibt die
              Fachstelle für Rassismusbekämpfung des Eidgenössischen
              Departements des Innern 2018 in ihrem{' '}
              <Link href='https://www.edi.admin.ch/edi/de/home/fachstellen/frb/bestellungen-und-publikationen/Bericht_FRB_2018.html'>
                Bericht
              </Link>
              . (ahl)
            </p>
            <hr />
            <p>
              <strong>Zum Weiterlesen</strong>
            </p>
            <p>
              Der Fall Mohamed Wa Baile:
              <br />
              <Link allowWordWrap href='318585579324'>
                Verdächtig, weil er die Augen niederschlug
              </Link>
            </p>
            <p>
              Ein Polizist erzählt, wie er bei der Arbeit als rassistisch
              beschimpft wird:
              <br />
              <Link allowWordWrap href='870276596352'>
                «Ich werde mehrmals jährlich als Rassist beschimpft»
              </Link>
            </p>
            <p>
              Wie fühlt es sich an, ständig in Polizeikontrollen zu geraten? Wie
              geht das Polizeidepartement mit der Kritik um?
              <br />
              <Link allowWordWrap href='22537987'>
                Jung, schwarz, verdächtig
              </Link>
            </p>
          </Box>

          <p>
            Alle Polizistinnen und Polizisten werden bereits in ihrer
            Grundausbildung zum Thema Rassismus und Racial Profiling geschult,
            später jährlich an Weiterbildungen. Wer aber erwartet, dass in einem
            Corps von 2200 Mitarbeitenden nie jemand einen Fehler macht, den
            muss ich enttäuschen. Fehler kommen vor. Wir können aber die
            Wahrscheinlichkeit dafür senken. Beim Thema Personenkontrollen wird
            es wohl immer Konflikte geben. Wenn wir jemanden mit dunkler
            Hautfarbe kontrollieren, hören wir wiederholt den Vorwurf, wir seien
            per se rassistisch. Das ist falsch und schadet unserer Arbeit.
            Stärker an der selbstkritischen Haltung arbeiten kann man aber
            immer.
          </p>
          <p>
            Natürlich haben wir auch dunkelhäutige Leute bei uns im Corps, wenn
            auch wenige. Um als Polizist oder Polizistin bei der Stadtpolizei
            Zürich arbeiten zu können, gilt die Voraussetzung: Wer am Ende der
            Ausbildung das Schweizer Bürgerrecht hat, kann sich bei uns
            bewerben, wenn er oder sie dazu alle anderen Anforderungen erfüllt.
            So will es das Gesetz, somit das Volk. Wenn es nach mir ginge,
            könnte sich jede Person, ob mit oder ohne Schweizer Pass, bewerben.
            Hauptsache: Sie oder er ist hier vollständig assimiliert. Hier zählt
            für mich vor allem die Sprache dazu.
          </p>
          <p>
            Wenn es um Sprache und Political Correctness geht, wirkt das auf
            mich aber oft künstlich. Allerdings glaube ich daran, dass Sprache
            sich auf die Haltung auswirkt und umgekehrt.
          </p>
          <p>
            Ich spüre nicht, dass die Diskussion durch die Demonstrationen und
            Kundgebungen eine andere Qualität bekommen hat. Rassismus ist seit
            Jahren ein Thema in der Schweiz, zumindest in der städtischen
            Gesellschaft.
          </p>
          <p>
            Aber es hilft wohl, Rassismus immer wieder zu thematisieren, damit
            sich jede Person die Frage stellt: «Was kann ich dagegen tun?»
            <span className='mark'>»</span>
          </p>
        </Person>

        <Person
          img={require('../../images/brotz.jpg')}
          id='brotz'
          quote='Die Redaktion und mich hat es durchgeschüttelt'
          info='Sandro Brotz, moderierte beide «Arena»-Sendungen zum Thema Rassismus (er hat schriftlich geantwortet)'
          setCurrent={setCurrentChapter}
        >
          <p>
            <span className='mark'>«</span>Anfang Juni letzten Jahres – rund
            eine Woche vor der ersten der beiden «Arena»-Sendungen zum Thema
            Rassismus – bin ich an einem Samstag in Zürich zufällig an einer
            «Black Lives Matter»-Kundgebung vorbeigekommen. Damals habe ich mir
            auch die Frage gestellt, ob die öffentliche Debatte in der Schweiz
            zum Thema Rassismus länger andauern oder ein kurzfristiges Phänomen
            bleiben wird. Angesichts der vielen und sehr unterschiedlichen
            Teilnehmerinnen und Teilnehmer war mein Eindruck, dass es den Nerv
            einer breiteren Gesellschaftsschicht getroffen hat.
          </p>
          <p>
            Einzelne Kundgebungsteilnehmerinnen und -teilnehmer haben mich
            darauf angesprochen, ob Rassismus auch demnächst ein Thema in der
            «Arena» sei. «Wir sind dran», habe ich geantwortet und hätte nie
            gedacht, kurz darauf selbst mitten in einer heftig geführten Debatte
            zu stehen.
          </p>
          <p>
            «Jetzt reden wir Schwarzen» lautete der Titel der ersten Sendung,
            die im Nachgang heftig kritisiert wurde. Unter anderem wegen der
            Zusammensetzung der Teilnehmenden – es diskutierten auch Weisse mit
            – und weil die angesprochenen Themen laut Ombudsstelle teilweise
            nicht sachgerecht erörtert worden waren.
          </p>
          <p>
            Persönlich hat mich dieser Prozess geprägt wie kaum ein anderer in
            meiner journalistischen Arbeit. Ich meine damit nicht allein den
            Shitstorm nach der ersten Sendung, sondern die Einsicht, dass die
            Herangehensweise an die Diskussion nicht geglückt ist. Das war
            zunächst schmerzhaft, weil die erste Sendung unseren eigenen
            Ansprüchen nicht gerecht geworden war. Wir haben nicht die Thematik,
            aber die Wirkung des Settings der Sendung in Kombination mit dem
            Titel unterschätzt.
          </p>
          <p>
            Zusammenfassend hat es die Redaktion und mich durchgeschüttelt, aber
            auch weitergebracht. Journalistisch und persönlich. Es hat nicht nur
            dazu geführt, dass wir einen zweiten Anlauf mit einer anderen
            Zusammensetzung und mit einem runden Tisch im Studio genommen haben
            – es hat auch das Bewusstsein für sensible Themen und deren
            Umsetzung noch mehr geschärft. Ich denke, dasselbe gilt für das Land
            insgesamt.
          </p>
          <p>
            Bei SRF haben sich im Nachgang auch Netzwerke und Arbeitsgruppen zu
            verschiedenen Diversity-Bereichen gebildet. Mit einzelnen Gästen aus
            der ersten und zweiten Rassismus-«Arena» habe ich bis heute Kontakt.
          </p>
          <p>
            Demgegenüber habe ich den Eindruck, dass die Thematik der «Black
            Lives Matter»-Kundgebungen in der Politik nicht wirklich auf grossen
            Nachhall gestossen ist. Letztlich ist die Rassismus-Debatte aber –
            wie viele andere Themen auch – von der Corona-Krise verdrängt
            worden.
            <span className='mark'>»</span>
          </p>
        </Person>

        <Person
          img={require('../../images/el-maawi.jpg')}
          id='el-maawi'
          quote='Die Betroffenen werden nun mehr einfordern'
          info='Rahel El-Maawi, Lehrbeauftragte für Soziokultur, Beraterin für diversitätsorientierte Organisationskultur; Aktivistin beim Netzwerk Schwarzer Frauen und non-binärer Menschen Bla*Sh'
          setCurrent={setCurrentChapter}
        >
          <p>
            <span className='mark'>«</span>Wir stehen nicht nur ein Jahr nach
            der Ermordung von George Floyd, sondern auch 27 Jahre nach der
            Einführung der Rassismusstrafnorm in der Schweiz. Und der Diskurs um
            Rassismus hier im Land ist noch älter. Er ist zum Glück immer
            hörbarer geworden – gerade während des letzten Jahres, auch dank den
            Medien. Die Politik aber hat dazu kaum Statements abgegeben. Auch
            bei Behörden scheint es, dass sie noch immer grossen Respekt davor
            haben, deutlich zu werden in diesem Thema.
          </p>
          <p>
            Es gab dennoch mutige Schritte. Die Stadt Zürich erarbeitet, wie sie
            mit rassistischen Häusernamen umgehen möchte, die Stadt Bern hat
            entschieden, jene Personen, die rassistische Stellen im Wandbild im
            Schulhaus Wylergut übermalt haben, nicht anzuzeigen, das Bild
            übermalt zu lassen und es so einem Museum zu übergeben. Für diese
            Fortschritte jedoch haben selbst organisierte Gruppen jahrelang
            gekämpft. Ich weiss von Briefen, die in den 1990er-Jahren den beiden
            Städten zugesandt wurden.
          </p>
          <Box title='Häusernamen im Niederdorf in Zürich'>
            <p>
              Im Mai 2020 wandte sich das{' '}
              <Link href='https://mirsindvoda.ch/medienmitteilung-schluss-mit-rassismus-im-doerfli'>
                «Kollektiv Vo da»
              </Link>{' '}
              in einem offenen Brief an das Amt für Städtebau in Zürich und
              forderte, dass rassistische Namen von drei Liegenschaften
              gewechselt und ein rassistisches Wandbild entfernt werden sollen.
            </p>
            <p>
              Da die gewünschte Reaktion ausblieb, wandte sich «Vo da» im Juni
              2020 direkt an Stadtpräsidentin Corine Mauch. Nach einem Aufruf
              über Social Media des «Vo da» meldeten sich rund 100 weitere
              Personen bei Mauch, um das Anliegen des Kollektivs zu
              unterstützen.
            </p>
            <p>
              Auf Vorschlag von Corine Mauch setzte der Stadtrat im Juli 2020
              die verwaltungsinterne «Projektgruppe Rassismus im öffentlichen
              Raum (PG RiöR)» ein. Diese legte im März 2021 ihren{' '}
              <Link href='https://www.stadt-zuerich.ch/prd/de/index/stadtentwicklung/integrationsfoerderung/integrationsthemen/diskriminierungsbekaempfung.html'>
                Abschlussbericht
              </Link>{' '}
              vor, in dem sie darlegt, wie die Stadt zukünftig mit rassistischen
              Zeitzeichen im öffentlichen Raum umgehen kann.
            </p>
            <p>
              Im April 2021{' '}
              <Link
                allowWordWrap
                href='https://www.stadt-zuerich.ch/prd/de/index/ueber_das_departement/medien/medienmitteilungen/2021/april/210408.html'
              >
                verkündete der Stadtrat
              </Link>
              , dass er gewisse Inschriften und Wandbilder im Niederdorf
              entfernen lassen oder in einen historischen Zusammenhang setzen
              wolle.
            </p>
            <p>
              Im Zürcher Gemeinderat gingen auch kritische Vorstösse zum Thema
              der Häusernamen ein. (ahl)
            </p>
            <hr />
            <p>
              <strong>Zum Weiterlesen</strong>
            </p>
            <p>
              Wie die Stadt Zürich dabei vorgeht und was das für private
              Eigentümer bedeutet:
              <br />
              <Link allowWordWrap href='279903247659'>
                Die rassistischen Häusernamen kommen weg
              </Link>
            </p>
            <p>
              Aktivist Dembah Fofanah bekämpft rassistische Häusernamen im
              Niederdorf. Hier kontert er die Argumente der Gegner:
              <br />
              <Link allowWordWrap href='902427692659'>
                Sie bekämpfen Rassismus im Niederdorf
              </Link>
            </p>
            <p>
              Geschnitzte Köpfe in der Aula des Schulhauses Hirschengraben
              werden kontextualisiert:
              <br />
              <Link allowWordWrap href='886434025208'>
                Die umstrittene Völkerschau im Schulhaus
              </Link>
            </p>
          </Box>
          <Box title='Wandbild im Schulhaus Wylergut in Bern'>
            <p>
              Das Wandbild im Schulhaus Wylergut stammt aus dem Jahr 1949 und
              zeigt unter anderem drei stereotype Darstellungen eines
              chinesischen, eines afrikanischen und eines amerikanisch-indigenen
              Menschen.
            </p>
            <p>
              <img
                className='ui image fluid'
                src={require('../../images/wandbild-wylergut.jpg')}
              />
            </p>
            <p>
              2019 schrieb die{' '}
              <Link
                allowWordWrap
                href='https://www.bern.ch/themen/kultur/kunst-im-offentlichen-raum/wandbild-wylergut'
              >
                Stadt Bern einen Wettbewerb
              </Link>{' '}
              aus, um einen Umgang mit den rassistischen Stereotypen zu finden,
              welche das als «erhaltenswert» eingestufte Wandalphabet zeigt.
            </p>

            <p>
              Im Juni 2020 übermalten{' '}
              <Link
                allowWordWrap
                href='https://www.bernerzeitung.ch/unbekannte-uebermalen-rassistisches-wandbild-978227477208'
              >
                Unbekannte Teile des Wandbildes
              </Link>{' '}
              und verlangten dessen Entfernung. Zwischenzeitlich wurde der
              Buchstabe N mit einem Nashorn überklebt. Der Aufkleber löste sich
              jedoch immer wieder. Später entschied der Berner Gemeinderat, dass
              es keine strafrechtliche Verfolgung des Übermalens geben soll – er
              könne die Wut, Ungeduld und Kritik am Wandbild nachvollziehen.
            </p>
            <p>
              2021 stellte die Stadt Bern die Resultate des Wettbewerbs
              öffentlich vor. Gewonnen hat das Projekt des Vereins{' '}
              <Link allowWordWrap href='https://www.daswandbildmussweg.ch'>
                «Das Wandbild muss weg!»
              </Link>
              , welches vorsieht, das Bild zu entfernen und in ein Museum zu
              verlegen. (ahl)
            </p>
          </Box>

          <p>
            Ich arbeite regelmässig mit Schulklassen. Und stellte fest: Für
            Schüler*innen mit Rassismuserfahrung war das vergangene Jahr sehr
            bewegend. Viele haben eine Sprache gefunden, um auszudrücken, was
            ihnen passiert. Die Wortkombination Schule und Rassismus stösst
            jedoch noch immer viele vor den Kopf. Dabei ist das keine
            persönliche Anfeindung, sondern eine Tatsache, dass wir alle,
            wirklich alle, eine bestimmte Bewertung von Menschen gelernt haben,
            weil wir in einem rassistischen System gross geworden sind.
          </p>
          <p>
            Auch mit vielen Journalist*innen stand ich während des letzten
            Jahres intensiv in Kontakt – bis zu vier Stunden Medienanfragen habe
            ich im Anschluss an meinen eigentlichen Job jeweils beantwortet. Den
            wenigen anderen Fachpersonen ging es oft ähnlich. Wir leisteten auch
            viel Hintergrundarbeit, weil die Medien das Wissen im Umgang mit dem
            Thema in kürzester Zeit nachholen mussten.
          </p>
          <p>
            Wenn ich Firmen und Hochschulen berate, stelle ich fest, dass es
            Nachholbedarf gibt. Viele der Diversity-Beauftragten wissen viel
            über sexuelle Gewalt und die Inklusion von Menschen mit Behinderung.
            Aber nicht zwingend auch über rassistische Gewalt und wie man sich
            dabei verhält. Wenn es in Unternehmen zu rassistischer
            Diskriminierung kam, spürte ich oft Abwehrreflexe – «das findet bei
            uns doch nicht statt». Ich erlebe dann oft eine grosse Überforderung
            und Hilflosigkeit. Es zeigt, die meisten von uns haben nicht
            gelernt, darüber zu sprechen und haben auch zu wenig Wissen im
            Umgang damit.
          </p>
          <p>
            Ich spüre aber auch einen Willen, die interne Kultur verändern zu
            wollen. Grosse Veränderungen waren in diesem Jahr trotzdem nicht zu
            sehen, es braucht weiterhin Geduld für die betroffenen Personen, bis
            sich eine antirassistische Kultur ausbreitet. Dennoch glaube ich,
            dass die betroffenen Menschen selbst nun mehr einfordern werden und
            dass das möglich geworden ist, weil heute öffentlich über das Thema
            diskutiert wird.
          </p>
          <p>
            Ich wünsche mir mehr Präsenz und Repräsentation von Schwarzen
            Menschen und Menschen mit ersichtlicher Migrationserfahrung in der
            Öffentlichkeit, in den Medien, in Schulleitungen, in der Politik, in
            Behörden, in allen Schlüsselpositionen. Das ermutigt die jüngere
            Generation und zeigt ihr, welche Wege möglich sind.
          </p>
          <p>
            Ich wünsche mir auch auf der individuellen Ebene, dass weisse
            Personen bereit sind, sich mit Rassismus auseinanderzusetzen, nicht
            mehr schweigen, und sich klar antirassistisch ausdrücken. Es braucht
            eine aktive Praxis, sonst gelingt es uns nicht, eine
            antirassistische Kultur aufzubauen. Und vor allem wünsche ich mir,
            dass wir als Gesellschaft über die Verwobenheit der Schweiz mit
            kolonialen Machenschaften sprechen lernen.
            <span className='mark'>»</span>
          </p>
        </Person>
      </div>

      <div
        className={
          isDesk ? 'ui vertical segment infront' : 'ui vertical segment'
        }
        style={{ backgroundColor: '#fff' }}
      >
        <div className='ui graphic container'>
          <img
            className='ui image fluid'
            src={require('../../images/basel.jpg')}
          />
          <div className='ta secondary caption'>
            Nicht nur in Zürich und Bern gingen im Juni 2020 viele auf die
            Strasse, um gegen Rassismus zu protestieren. Auch in Lausanne,
            St.Gallen, Genf und Luzern. Im Bild: Eine Aufnahme von der
            Demonstration in Basel. Foto: Georgios Kefalas/ Keystone
          </div>
        </div>
      </div>

      <div id='sprache' className='ui inverted vertical segment'>
        <div className='ui container'>
          <h3>Q&A zur Sprache</h3>
          <div className='ui equal width stackable two column grid'>
            <div className='column'>
              <div className='question'>Wofür steht PoC?</div>
              <p>
                People of Color (Einzahl: Person of Color) ist eine
                Selbstbezeichnung, die Menschen verwenden, die Rassismus
                erfahren. Sie bezieht sich nicht auf die Hautfarbe einer Person.
                People of Color kann als englischer Begriff auch im Deutschen
                verwendet werden. Man kann ihn auch kombinieren, Beispiel:
                Familie of Color, Mädchen of Color.
              </p>
            </div>
            <div className='column'>
              <div className='question'>Was bedeutet BIPOC?</div>
              <p>
                Black, Indigenous and People of Color ist ebenfalls eine
                politische Selbstbezeichnung von Personen mit
                Rassismuserfahrung.
              </p>
            </div>
            <div className='column'>
              <div className='question'>
                Ich habe immer wieder «Schwarze Person» gelesen, wieso ist das S
                gross?
              </div>
              <p>
                Mit grossem S geschrieben, ist Schwarz eine politische
                Selbstbezeichnung, bezieht sich also nicht auf die Hautfarbe
                einer Person, sondern auf die geteilte Rassismuserfahrung. Es
                ist auch kein Adjektiv oder eine Art, vermeintlich biologische
                Merkmale zu benennen. Mit dem Begriff wird eine
                gesellschaftliche Position beschrieben, die von Rassismus
                betroffen ist, beziehungsweise Schwarze Menschen sind Menschen,
                die Rassismuserfahrungen machen.
              </p>
            </div>
            <div className='column'>
              <div className='question'>
                Wie verhält es sich mit der Bezeichnung «weiss», und warum sehe
                ich sie immer wieder kursiv geschrieben?
              </div>
              <p>
                Kursiv geschrieben, bezeichnet weiss beziehungsweise weisse
                Menschen eine gesellschaftliche Position, in der die
                entsprechenden Personen Privilegien innehaben. Der Begriff
                bezieht sich nicht auf biologische Merkmale. Er bezeichnet
                Personen, die keine Rassismuserfahrungen machen – wobei sie von
                anderen Formen der Diskriminierung betroffen sein können.
              </p>
            </div>
            <div className='column'>
              <div className='question'>Darf ich noch «farbig» sagen?</div>
              <p>
                Dieser Begriff stammt aus der Kolonialzeit und trägt eine
                negative Konnotation. Kritiker:innen bemängeln des Weiteren,
                dass der Begriff die Vorstellung mittrage, es gebe «unfarbige»
                Menschen, die als Norm gelten. Es ist ein hierarchisches
                Sprechverhältnis, wenn die einen bezeichnet werden und die
                anderen nicht. Diverse Fachpersonen raten also davon ab, den
                Begriff zu verwenden.
              </p>
            </div>
            <div className='column'>
              <div className='question'>
                Was ist mit der Bezeichnung «dunkelhäutig»?
              </div>
              <p>
                Diese Bezeichnung wurde Schwarzen Menschen von weissen gegeben.
                Oft wird der Begriff verwendet, um jemanden aus einer Gruppe
                gesondert zu bezeichnen, ohne dass etwa Weisse aus der Gruppe
                auch entsprechend als hellhäutig bezeichnet werden. Diverse
                Fachpersonen raten also davon ab, den Begriff zu verwenden.
              </p>
            </div>
            <div className='column'>
              <div className='question'>
                Und wie steht es um den Begriff «Rasse»?
              </div>
              <p>
                Sogenannte Menschenrassen gibt es biologisch gesehen nicht.
                Trotzdem wurde dieses Konstrukt aufgebaut, um etwa in der Zeit
                des Kolonialismus und Nationalsozialismus die Überlegenheit
                bestimmter Personengruppen zu legitimieren, beziehungsweise die
                Ausbeutung und Ermordung anderer Personengruppen ebenso zu
                rechtfertigen. Diverse Fachpersonen raten also davon ab, den
                Begriff zu verwenden.
              </p>
            </div>
            <div className='column'>&nbsp;</div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ marginTop: '2em' }}>
        <div className='ui graphic container'>
          <img
            className='ui image fluid'
            src={require('../../images/bern.jpg')}
          />
          <div className='ta secondary caption'>
            Eine Teilnehmerin der Anti-Rassismus-Demonstration in Bern hält ein
            Schild in die Luft: «Bildet euch», steht darauf geschrieben. Bern,
            13. Juni 2020. Foto: Peter Klaunzer/ Keystone
          </div>
        </div>
      </div>

      <div
        id='links'
        className='ui vertical segment'
        style={{ paddingTop: '0' }}
      >
        <div className='ui text container'>
          <div className='ta text'>
            <h4>Literatur, Podcasts und Websites zum Thema</h4>
            <h6>Web</h6>
            <p>
              <Link href='https://histnoire.ch'>Histnoire</Link>
              <br />
              Diese Website stellt Schwarze Frauen* vor, die sich in der
              Schweizer Öffentlichkeit engagier(t)en. Hinter der
              Online-Dokumentation steht die Wissenschaftlerin Jovita Dos Santos
              Pinto. Sie forscht am Interdisziplinären Zentrum für
              Geschlechterforschung der Universität Bern.
            </p>
            <p>
              <Link href='https://www.instagram.com/vor.bilder.buecher'>
                Vor.Bilder.Bücher
              </Link>
              <br />
              Auf diesem Instagram-Kanal stellt das Netzwerk Bla*Sh Kinder- und
              Jugendbücher vor, in denen Protagonist:innen of Color vorkommen.
            </p>
            <p>
              <Link href='https://www.instagram.com/wasihrnichtseht/?hl=en'>
                Was ihr nicht seht
              </Link>
              <br />
              Auf diesem Instagram-Kanal machen Schwarze Menschen ihre
              Erfahrungen mit Alltagsrassismus in Deutschland sichtbar.
            </p>
            <h6>Bücher</h6>
            <p>
              <div className='booktitle'>Why We Matter</div>
              <div className='sans'>Emilia Roig</div>
              Aufbau-Verlag, Berlin 2021 . 397 S., ca. 35 Fr.
              <br />
              Die französische Aktivistin und Politologin Emilia Roig lässt in
              ihrem Buch Rassismus und Black Pride, Antisemitismus und
              Auschwitz, Homophobie und Queerness, Patriarchat und Feminismus
              aufeinanderprallen, verwoben mit ihrer eigenen Familiengeschichte.
            </p>
            <p>
              <div className='booktitle'>
                Was weisse Menschen nicht über Rassismus hören wollen aber
                wissen sollten aber wissen sollten.
              </div>
              <div className='sans'>Alice Hasters</div>
              Hanser-Verlag, München 2020. 224 S., ca. 17 Fr.
              <br />
              Sich mit eigenen rassistischen Verhaltensweisen zu konfrontieren,
              ist schmerzhaft. Alice Hasters begleitet einen in diesem Buch
              dabei, geduldig und eindringlich.
            </p>

            <p>
              <div className='booktitle'>
                Gib mir mal die Hautfarbe. Mit Kindern über Rassismus sprechen.
              </div>
              <div className='sans'>
                Olaolu Fajembola, Tebogo Nimindé-Dundadengar
              </div>
              Beltz, Weinheim 2021. 256 S., ca. 20 Fr.
              <br />
              Was tun, damit Rassismus im Kopf von Kindern erst gar nicht
              entsteht? Wie erkennen Eltern Rassismusfallen im Alltag? Wie
              vermitteln sie ihrem Nachwuchs, dass alle Kinder gleichwertig
              sind? Dieses Buch bietet praktische Tipps, Hintergrundinfos und
              Checklisten.
            </p>

            <p>
              <div className='booktitle'>Eure Heimat ist unser Albtraum.</div>
              <div className='sans'>
                Fatma Aydemir, Hengameh Yaghoobifarah (Hrsg.)
              </div>
              Ullstein, Berlin 2019. 208 S., ca. 26 Fr.
              <br />
              14 deutschsprachige Schreibende nehmen in dieser Essaysammlung das
              Konzept «Heimat» unter die Lupe, genauer gesagt, dessen völkische
              Verklärung. Wie wirkt sich Rassismus auf die Familie aus, das
              Vertrauen gegenüber Behörden, auch die eigene Sexualität? Das
              erzählen unter anderen Margarete Stokowski, Max Czollek, Mithu
              Sanyal und Olga Grjasnowa.
            </p>
            <p>
              <div className='booktitle'>The Hate you give.</div>
              <div className='sans'>Angie Thomas</div>
              Cbt, München 2017. 512 S., ca. 32 Fr.
              <br />
              Eigentlich ein Jugendbuch über die 16-jährige Protagonistin Starr,
              deren bester Freund Khalil erschossen wird. Das Erstlingswerk der
              US-amerikanischen Autorin über Polizeigewalt packt und erschüttert
              aber auch Erwachsene. «The Hate you give» wurde 2018 verfilmt
              (verfügbar auf Amazon Prime).
            </p>
            <p>
              <div className='booktitle'>Americanah.</div>
              <div className='sans'>Chimamanda Ngozi Adichie</div>
              Fischer Taschenbuch Verlag, Frankfurt 2015. 608 S., ca. 23 Fr.
              <br />
              Nigeria in den 90er-Jahren. Ifemelu und Obinze leben ihre Liebe,
              die Militärdiktatur zwingt sie aber, ihr Heimatland zu verlassen.
              Ifemelu reist in die USA, arbeitet an der Princeton University und
              erfährt zum ersten Mal in ihrem Leben, wie sie als Schwarze Person
              kategorisiert wird. Obinze schlägt sich derweil in London durch,
              als illegaler Einwanderer. Jahre später treffen sie sich wieder –
              zurück in Nigeria. Ein preisgekrönter Roman über Menschlichkeit
              und Identität.
            </p>
            <p>
              <div className='booktitle'>Racial Profiling.</div>
              <div className='sans'>
                Mohamed Wa Baile/Serena O. Dankwa/Tarek Naguib/Patricia
                Putschert/Sarah Schilliger (Hrsg.)
              </div>
              Transcript-Verlag, Bielefeld 2019. 336 S., ca. 34 Fr.
              <br />
              Ein Sammelband, in dem Personen aus wissenschaftlicher,
              künstlerischer und aktivistischer Perspektive auf diese
              behördliche Praxis in der Schweiz blicken und sie einbetten in
              einen weiteren gesellschaftlichen Kontext.
            </p>
            <p>
              <div className='booktitle'>
                Wie Rassismus aus Wörtern spricht.{' '}
              </div>
              <div className='sans'>
                Susan Arndt, Nadja Ofuatey-Alazard (Hrsg.)
              </div>
              Unrast-Verlag, Münster 2019. 786 S., ca. 44 Fr.
              <br />
              Ein kritisches Nachschlagewerk dazu, wie der Kolonialismus bis
              heute in Diskursen, Strukturen und Begriffen konserviert wurde.
            </p>
            <h6>Zum Hören</h6>
            <p>
              <Link href='https://tupodcast.podigee.io'>Tupodcast</Link>
              <br />
              Tupoka Ogette ist Autorin und Anti-Rassismus-Trainerin. In ihrem
              Podcast spricht sie unter dem Motto «Gespräche unter Schwestern»
              mit anderen Schwarzen Frauen über Widerstand, Empowerment, Leben
              und Überleben und vieles mehr.
            </p>
            <p>
              <Link href='https://www.exitracism.de'>Exit Racism</Link>
              <br />
              Ebenfalls von Tupoka Ogette. Eine rassismuskritische Reise, auch
              in Hörbuchform, gelesen von der Autorin und weiteren Stimmen, mit
              Gedankenexperimenten zum Mitmachen. Ein Muss.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          [
            'Recherche, Interviews',
            'Alexandra Kedves, Martin Fischer, Aleksandra Hiltmann'
          ],
          ['Umsetzung', 'Mathias Lutz']
        ]}
      />
    </div>
  )
}
